import React from "react";
import moment from "moment-timezone";
import { BusinessCreditReportStatePII } from "../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
}

const BCreditRiskTrackerDetails: React.FunctionComponent<IProps> = (props) => {
    const hasReportObject = props.reportObject.businessCompanyReport !== null;
    return (
        <React.Fragment>
            <div className="line-divider margin-vertical-xs"></div>

            <div className="row between-sm score-details">
                <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                    <div className="data-row condensed row">
                        <div className="col-xs col-sm-12 col-no-gutter">
                            <div className="data-label" id="ma-summary-employees">
                                Last Changed
                            </div>
                        </div>
                        <div className="col-xs col-sm-12 col-no-gutter flex-grow-null-xs">
                            <div className="data-value no-padding " aria-labelledby="ma-summary-employees">
                                <span className="emphasize-3">
                                    {hasReportObject
                                        ? moment(props.reportObject?.businessCompanyReport?.credit_score_and_limit?.date_of_latest_rating_Change).format(
                                              "MM/DD/YYYY"
                                          )
                                        : "--"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                    <div className="data-row condensed row">
                        <div className="col-xs col-sm-12 col-no-gutter">
                            <div className="data-label" id="ma-summary-devices">
                                PAYDEX® Score
                            </div>
                        </div>
                        <div className="col-xs col-sm-12 col-no-gutter flex-grow-null-xs">
                            <div className="data-value no-padding " aria-labelledby="ma-summary-devices">
                                <span className="emphasize-3">
                                    {hasReportObject ? props.reportObject.businessCompanyReport?.credit_score_and_limit?.paydex_score : "--"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-sm col-no-gutter text-align-right-sm flex-grow-null">
                    <div className="data-row condensed row">
                        <div className="col-xs col-sm-12 col-no-gutter">
                            <div className="data-label" id="ma-summary-risks">
                                Credit Limit
                            </div>
                        </div>
                        <div className="col-xs col-sm-12 col-no-gutter flex-grow-null-xs">
                            <div className="data-value no-padding " aria-labelledby="ma-summary-risks">
                                <span className="emphasize-3">
                                    {hasReportObject ? props.reportObject?.businessCompanyReport?.credit_score_and_limit?.current_recommended_credit_limit : "--"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BCreditRiskTrackerDetails;
